export const GRID_INFORMATION = 'information';
export const GRID_DIVIDER = 'divider';
export const GRID_ACTION = 'action';
